import { qs, qsa, getScrollOffset } from "../inc/dom.js";

const initReadMore = () => {
    const body = document.getElementById("qc-body");
    const toggles = qsa("[data-qc-toggle]");
    if (!body || !toggles.length) return;

    const render = () => {
        const open = body.classList.contains("show");
        toggles.forEach((toggle) => {
            toggle.textContent = open ? "Read Less" : "Read More";
            toggle.setAttribute("aria-expanded", open ? "true" : "false");
        });
    };

    body.addEventListener("shown.bs.collapse", () => {
        render();
        window.scrollTo({
            top: body.getBoundingClientRect().top + window.pageYOffset - getScrollOffset() - 24,
            behavior: "smooth",
        });
    });

    body.addEventListener("hidden.bs.collapse", render);
    render();
};

const initToggleVisibility = () => {
    const toggles = qsa("[data-qc-toggle]");
    const pairs = qsa("[data-qc-reveal]")
        .map((reveal) => {
            const index = toggles.indexOf(qs("[data-qc-toggle]", reveal));
            return { reveal, watch: index > 0 ? toggles[index - 1] : null };
        })
        .filter((pair) => pair.watch);
    if (!pairs.length) return;

    let queued = false;

    const apply = () => {
        queued = false;
        const edge = getScrollOffset();
        pairs.forEach((pair) => {
            pair.reveal.classList.toggle("is-visible", pair.watch.getBoundingClientRect().bottom <= edge);
        });
    };

    const onScroll = () => {
        if (queued) return;
        queued = true;
        window.requestAnimationFrame(apply);
    };

    apply();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll, { passive: true });
};

initReadMore();
initToggleVisibility();
